import { Pipe, PipeTransform } from "@angular/core";

import { AddressType } from "../../apis/networkdashboard/graphql/graphql";

@Pipe({ name: "location_address", standalone: true })
export class LocationAddressPipe implements PipeTransform {
  transform(address: AddressType | null | undefined): string {
    if (!address) return "";
    const city = address.city ?? "";
    const capitalizedCity = city.charAt(0).toUpperCase() + city.slice(1);
    return `${capitalizedCity} (${address.street ?? ""} ${address.number ?? ""})`.trim();
  }
}
